import React, { ReactElement } from 'react';

import { TAG_DAID } from 'data-automation-ids/data-automation-ids';

import './Tag.scss';

interface TagProps {
	values: string[];
	label: string;
	maxChars?: number;
	tooltipId?: string;
}

export const Tag: React.FC<TagProps> = ({ values, label, tooltipId, maxChars = 40 }) => {
	const renderSingleValue = (value: string): ReactElement => {
		const showTooltip = value.length > maxChars - 3;
		const trimmedText = showTooltip ? `${value.slice(0, maxChars)}...` : value;
		return (
			<span
				className="tag-text"
				data-tooltip-id={showTooltip ? tooltipId : undefined}
				data-tooltip-content={showTooltip ? value : undefined}
			>
				{trimmedText}
			</span>
		);
	};

	return (
		<div className="tag" data-automation-id={TAG_DAID}>
			<span className="tag-label">{label}:</span>
			<div className="tag-values-container">{values.map(renderSingleValue)}</div>
		</div>
	);
};
